/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

import React, { Component } from "react";
import styled from "styled-components";
import { TiHeartOutline, TiHeart } from "react-icons/ti";
import PropTypes from "prop-types";
import * as foodSelectors from "../selectors/food";

const StyledContainer = styled.div`
  cursor: pointer;
  display: inline-flex;
  flex-direction: row;
  color: grey;
  justify-content: center;
  align-items: center;
`;

class FavouriteButton extends Component {
  constructor(props) {
    super(props);

    this.state = {
      liked: false
    };
  }

  componentDidMount() {
    const { liked } = this.props;

    this.setState({
      liked: liked
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.props.liked !== nextProps.liked ||
      this.state.liked !== nextProps.liked
    ) {
      this.setState({
        liked: nextProps.liked
      });
    }
  }

  onClicked = e => {
    const { onClicked } = this.props;

    e.stopPropagation();
    this.setState({
      liked: !this.state.liked
    });

    if (onClicked) {
      onClicked(!this.state.liked);
    }
  };

  render() {
    const { liked } = this.state;
    const { style } = this.props;

    return (
      <StyledContainer
        style={style}
        onClick={e => {
          this.onClicked(e);
        }}
      >
        {liked ? (
          <TiHeart color={"#FF69B4"} size={"1.5em"} />
        ) : (
          <TiHeartOutline color={"lightgrey"} size={"1.5em"} />
        )}
      </StyledContainer>
    );
  }
}

FavouriteButton.propTypes = {
  onClicked: PropTypes.func.isRequired,
  liked: PropTypes.bool,
  style: PropTypes.object
};

FavouriteButton.defaultProps = {
  liked: false
};

export default FavouriteButton;



// WEBPACK FOOTER //
// ./src/components/FavouriteButton.js